import { DISMISS_WARNING } from "../constants";

export const dismissWarning = () => dispatch => {
  dispatch({ type: DISMISS_WARNING });
};
